var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankRgs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525455",
    d: "M2.7 25.8v-2.1h4.9v-2.5H0v13.2h6.3l1.9-1.9v-4.7l-2-1.9-3.5-.1Zm2.7 6H2.7v-3.5h2.7v3.5Zm6.3-10.7L9 34.3h2.7l.6-3.1h3.5l.6 3.1h2.7l-2.7-13.2h-4.7Zm1.1 7.6 1-5h.5l1 5h-2.5Zm13.5-2.2H23v-5.4h-2.7v13.2H23v-5.2h3.3v5.2H29V21.1h-2.7v5.4Zm11.3 1.1 2.3-6.5h-2.8l-1.8 5.2h-1.5v-5.2H31v13.2h2.8v-5.4h1.4l1.9 5.4H40l-2.4-6.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#990032",
    d: "M9.7 18.9h2.7V8.2h3.5V5.7H9.7v13.2ZM.1 5.7v13.2h2.7v-3.3h3.5l2-1.9v-6l-2-2H.1ZM5.5 13H2.7V8.2h2.7V13h.1Zm13.9-4.8h3.9V5.7h-4.7l-1.9 1.9V17l1.9 1.9h4.7v-2.6h-3.9V8.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankRgs);
export default ForwardRef;